import jQuery from 'jquery'
import { Calendar } from '@fullcalendar/core'
import listPlugin from '@fullcalendar/list'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import interactionPlugin from '@fullcalendar/interaction'
import rrulePlugin from '@fullcalendar/rrule'
import nlLocale from '@fullcalendar/core/locales/nl'
import enLocale from '@fullcalendar/core/locales/en-gb'
import deLocale from '@fullcalendar/core/locales/de'
import { isEqual } from 'lodash'

(function ($) {
  $.fn.calendar = function (opts, cb) {
    if (typeof cb === 'undefined') {
      cb = function () {}
    }

    const hideLocations = ($form, ids) => {
      if (!Array.isArray(ids)) {
        ids = [ids]
      }

      // Remove empty values (e.g. placeholder)
      ids = ids.filter(a => !!a)

      if (ids.length === 0) {
        // Enable all Location options
        $form.find('[name=LocationID] option[data-warehouse-id]').prop('disabled', false)
      } else {
        // First, disable all options
        $form.find('[name=LocationID] option[data-warehouse-id]').prop('disabled', true)

        // Then enable all that have matches
        ids.forEach(id => {
          $form.find(`[name=LocationID] option[data-warehouse-id='${id}']`).prop('disabled', false)
        })
      }

      $form.find('.selectpicker').selectpicker('refresh')
    }

    return this.each(function () {
      const $calendar = $(this)
      const $form = $(this).closest('form')
      $form.find('input, select').change(function () {
        calendar.refetchEvents()
        hideLocations($form, $form.find('[name=WarehouseID]').val())
      })

      const eventSources = [
        'dataduiker/fcSubscriptionAgenda'
      ].map(id => {
        return {
          id,
          url: window.ajaxURL,
          extraParams () {
            const formParams = {}
            $form.serializeArray().forEach(entry => {
              if (typeof formParams[entry.name] !== 'undefined') {
                formParams[entry.name] = new Array(formParams[entry.name])
                formParams[entry.name].push(entry.value)
              } else {
                formParams[entry.name] = entry.value
              }
            })
            return {
              function: id,
              ShowSelfYN: $calendar.data('showSelf') || 0,
              ...$calendar.data('filter'),
              ...formParams
            }
          }
        }
      })

      const getLocale = (locale) => {
        switch (locale) {
          case 'nl-NL':
            return nlLocale
          case 'en-GB':
            return enLocale
          case 'de-DE':
            return deLocale
          default:
            return nlLocale
        }
      }

      const locale = getLocale($calendar.data('locale') || 'nl-NL')

      const calendar = new Calendar($calendar.get(0), $.extend({
        locale,
        timeZone: 'Europe/Amsterdam',
        aspectRatio: 1.35,
        contentHeight: 'auto',
        height: 'auto',
        plugins: [
          listPlugin,
          timeGridPlugin,
          bootstrapPlugin,
          rrulePlugin,
          dayGridPlugin,
          interactionPlugin
        ],
        initialView: $calendar.data('initialView') || 'listWeek',
        themeSystem: 'bootstrap',
        nowIndicator: true,
        expandRows: true,
        noEventsText: 'Geen tijdsblokken gevonden. Probeer een andere dag, of selecteer een andere accommodatie.',

        headerToolbar: {
          start: 'title',
          center: '',
          end: $calendar.data('views') ? `${$calendar.data('views')} today prev,next` : 'today prev,next'
        },

        footerToolbar: {
          start: '',
          center: '',
          end: $calendar.data('views') ? `${$calendar.data('views')} today prev,next` : 'today prev,next'
        },

        buttonText: {
          list: 'Lijst',
          today: 'Terug'
        },

        allDaySlot: false,
        slotEventOverlap: false,
        slotDuration: '01:00:00',
        slotMinTime: '06:00:00',
        slotMaxTime: '22:30:00',
        validRange (nowDate) {
          if (typeof $calendar.data('validRange') !== 'undefined') {
            const [start, end] = $calendar.data('validRange').split(',')
            return {
              start: start || undefined,
              end: end || undefined
            }
          }

          return {
            start: nowDate,
            end: new Date(nowDate).setMonth(nowDate.getMonth() + 12)
          }
        },

        eventOrder: [
          'start',
          '-duration',
          'allDay',
          'title'
        ],
        progressiveEventRendering: true,

        eventSourceSuccess (res) {
          if (res.validRange && !isEqual(this.getOption('validRange'), res.validRange)) {
            this.setOption('validRange', res.validRange)
            this.refetchEvents()
          }
          return res.items
        },

        startParam: 'StartDate',
        endParam: 'EndDate',

        eventSources,

        eventDidMount: function (info) {
          const isMobile = window.matchMedia('only screen and (max-width: 767px)').matches
          if (!isMobile) {
            $(info.el).tooltip({ title: info.event.title, trigger: 'hover' })
          }

          const icon = info.event.extendedProps.icon
          if (icon) {
            // append whitespace instead of using styling to space the badge
            $(info.el).find('.fc-list-event-title a').text($(info.el).find('.fc-list-event-title a').text() + ' ')
            $(info.el).find('.fc-list-event-title').append(icon)
          }

          const employeeBadge = info.event.extendedProps.employeeBadge
          if (employeeBadge) {
            // append whitespace instead of using styling to space the badge
            $(info.el).find('.fc-list-event-title a').text($(info.el).find('.fc-list-event-title a').text() + ' ')
            $(info.el).find('.fc-list-event-title').append(employeeBadge)
          }

          // Check if the event type is "closure"
          if (info.event.extendedProps.Type === 'CLOSURE') {
            // Add class to indicate unavailable
            $(info.el).addClass('disabled text-decoration-none font-italic')
          }
        },

        dayCellDidMount: function ({ date, el }) {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          if (date < today) {
            $(el).addClass('disabled')
          }
        },

        loading (isLoading) {
          if (isLoading) {
            $calendar.addClass('loading')
          } else {
            $calendar.removeClass('loading')
          }
        }
      }, opts))

      $calendar.data('fc.calendar', calendar)

      calendar.render()

      cb(calendar)

      // Resize canvas to fix point mapping to CSS resizing
      window.addEventListener('resize', resize)
      resize()

      function resize () {
        //
      }
    })
  }

  $('[data-toggle=calendar]').calendar()
}(jQuery))
